// Vendor
import Checkbox from 'semantic-ui-checkbox'
import modal from 'bootstrap/js/dist/modal'
import '../../entrypoints/modules/semantic-ui-dropdown'
// Modules
import { fetchResults, buildPostJson } from './functions'
import { trans, SELECT_ALL_MATCHING, CLEAR_ALL_SELECTIONS } from '../../translator'

$.fn.checkbox = Checkbox

function initDropdowns (filterSetKeyPrefix, isActiveFiltering = true) {
  const dropdownConfig = {
    onAdd: function (addedValue, addedText, addedChoice) {
      const type = $(this)[0].getAttribute('id')
      handleFilterSelection(
        filterSetKeyPrefix,
        type,
        addedChoice[0].dataset.value,
        addedChoice[0].dataset.name,
        isActiveFiltering
      )
    },
    onRemove: function (addedValue, addedText, removedChoice) {
      const type = $(this)[0].getAttribute('id')
      handleFilterRemoval(
        filterSetKeyPrefix,
        type,
        removedChoice[0].dataset.value,
        removedChoice[0].dataset.name,
        false,
        isActiveFiltering
      )
    },
    fullTextSearch: 'exact'
  }

  $('#logs').dropdown(dropdownConfig)

  $('#record_status').dropdown(dropdownConfig)

  $('#issue_status').dropdown(dropdownConfig)

  $('#categories').dropdown(dropdownConfig)

  $('#priorities').dropdown(dropdownConfig)

  $('#locations').dropdown(dropdownConfig)

  $('#resolutions').dropdown(dropdownConfig)

  $('#permission_groups').dropdown(dropdownConfig)

  $('#teams').dropdown(dropdownConfig)

  $('#sites').dropdown(dropdownConfig)

  $('#record_type').dropdown({
    clearable: true,
    forceSelection: false,
    action: function (addedValue, value) {
      if (value === 'CHECKLIST') {
        showChecklistFilterModal()
      } else if (value === 'ISSUE') {
        $(this).dropdown('set selected', addedValue)
        enableIssueOnlyFilters()
        const type = $(this)[0].getAttribute('id')
        handleFilterSelection(
          filterSetKeyPrefix,
          type,
          'ISSUE',
          'ISSUE',
          isActiveFiltering
        )
      } else if (value === 'NOTE') {
        showNoteFilterModal()
      }
    }
  })

  $('#sms_thread_status').dropdown(dropdownConfig)

  // Handle Unsetting record type
  $('#record_type').change(function (e) {
    if (e.target.value === '') {
      handleFilterRemoval(filterSetKeyPrefix, 'record-type', null, null, false, isActiveFiltering)
      enableIssueOnlyFilters()
    }
  })

  initSelectAllMatching()
}

// With 0 or 1 items selected the lozenge's own × is enough, so the clear-all
// affordance only appears once the user has at least this many selections.
const MIN_SELECTIONS_FOR_CLEAR_ALL = 2

// Iterates over all dropdowns marked with data-select-all-filtered and enables
// the select-all / clear-all affordance on each. Called once from initDropdowns.
function initSelectAllMatching () {
  $('[data-select-all-filtered]').each(function () {
    enableSelectAllFiltered($(this))
  })
}

// Enables the select-all / clear-all affordance on a single Semantic UI
// multi-select dropdown. Safe to call for both flavours of dropdown in this
// codebase:
//   - <div class="ui ... dropdown"> with a <input type="hidden"> child (our
//     Twig-authored filter dropdowns).
//   - <select>-backed dropdowns where Semantic UI creates a wrapper <div>; pass
//     the wrapper ($select.parent()).
// Idempotent — calling twice on the same dropdown is a no-op.
//
// Behaviour once enabled:
//   - a persistent row at the top of the menu appears whenever the search term
//     is non-empty; clicking it selects every currently-matching item.
//   - a × icon next to the dropdown arrow appears when 2+ items are selected;
//     clicking it clears the whole selection. (Semantic UI's native
//     clearable:true only handles single-select dropdowns.)
function enableSelectAllFiltered ($dropdown) {
  if (!$dropdown || !$dropdown.length) return
  if ($dropdown.find('> .js-clear-all').length) return // already initialised

  // Ensure the data attribute is present so the CSS in raven-base.scss applies
  // consistently whether the caller opted in via the Twig attribute or via a
  // direct JS call on a select-backed dropdown.
  $dropdown.attr('data-select-all-filtered', 'true')

  const rowHtml = '<div class="item js-select-all">' +
    '<i class="square outline icon"></i>' +
    '<span class="js-select-all-label"></span>' +
    '</div>'

  const clearLabel = trans(CLEAR_ALL_SELECTIONS, {}, 'filters')
  const clearHtml = '<i class="remove icon js-clear-all" role="button" aria-label="' + clearLabel + '" title="' + clearLabel + '"></i>'

  $dropdown.find('> .menu').prepend(rowHtml)
  $dropdown.append(clearHtml)
  const $search = $dropdown.find('> input.search')
  const $row = $dropdown.find('> .menu > .js-select-all')
  const $label = $row.find('.js-select-all-label')
  const $clear = $dropdown.find('> .js-clear-all')
  // Div-backed dropdowns ship a hidden input; select-backed ones have the
  // original <select> as a direct child. Both fire 'change' when Semantic UI
  // updates the value.
  const $valueSource = $dropdown.children('input[type="hidden"], select').first()

  const currentValueArray = () => {
    const val = $dropdown.dropdown('get value')
    if (Array.isArray(val)) return val.filter(Boolean)
    return (val || '').toString().split(',').filter(Boolean)
  }

  const updateClearVisibility = () => {
    $clear.toggleClass('visible', currentValueArray().length >= MIN_SELECTIONS_FOR_CLEAR_ALL)
  }

  const update = () => {
    // Defer so Semantic UI finishes applying .filtered before we count.
    setTimeout(() => {
      $row.removeClass('filtered')
      const term = ($search.val() || '').trim()

      if (term === '') {
        // Strip stale .filtered Semantic UI may have left, but keep selected
        // (.active) items hidden so they stay out of the menu as lozenges.
        $dropdown.find('.menu > .item.filtered').not('.active').removeClass('filtered')
        $row.removeClass('visible')
        return
      }

      const $visible = $dropdown.find('.menu > .item:not(.filtered)').not('.js-select-all')
      if ($visible.length === 0) {
        $row.removeClass('visible')
        return
      }

      const selected = new Set(currentValueArray())
      const allSelected = $visible.toArray().every(el => selected.has(el.dataset.value))

      $row.find('i').attr('class', allSelected ? 'check square outline icon' : 'square outline icon')
      $label.text(trans(SELECT_ALL_MATCHING, { '%count%': $visible.length }, 'filters'))
      $row.addClass('visible')
    }, 0)
  }

  $search.on('input keyup', update)

  // mousedown (not click) so we preempt Semantic UI's own handlers — the row
  // would otherwise be treated as a normal item selection, and the × click
  // would bubble to the dropdown and toggle the menu open. The e.button guard
  // filters out right-click, which also fires mousedown.
  $dropdown.on('mousedown', '.js-select-all', function (e) {
    if (e.button !== 0) return
    e.preventDefault()
    e.stopPropagation()
    // Defensive: if search has been cleared, don't bulk-select everything.
    if (($search.val() || '').trim() === '') {
      update()
      return
    }
    selectVisible($dropdown)
    $search.val('').trigger('input')
    updateClearVisibility()
  })
  $clear.on('mousedown', function (e) {
    if (e.button !== 0) return
    e.preventDefault()
    e.stopPropagation()
    $dropdown.dropdown('clear')
    // Reset search too — leaving it behind makes the placeholder bleed through.
    $search.val('').trigger('input')
    updateClearVisibility()
  })
  // Refresh on selection change so individual ticks update the row.
  $valueSource.on('change', () => {
    updateClearVisibility()
    update()
  })

  // Catches programmatic search-clears Semantic UI does on menu re-open.
  const existingOnShow = $dropdown.dropdown('setting', 'onShow')
  $dropdown.dropdown('setting', 'onShow', function () {
    if (typeof existingOnShow === 'function' && existingOnShow !== $.fn.dropdown.settings.onShow) {
      existingOnShow.apply(this, arguments)
    }
    update()
  })

  updateClearVisibility()
}

function selectVisible ($dropdown) {
  const visibleIds = $dropdown.find('.menu > .item:not(.filtered)')
    .not('.js-select-all')
    .map(function () { return this.dataset.value })
    .get()
    .filter(Boolean)
  if (!visibleIds.length) return
  const val = $dropdown.dropdown('get value')
  const current = Array.isArray(val)
    ? val.filter(Boolean)
    : (val || '').toString().split(',').filter(Boolean)
  const merged = Array.from(new Set([...current, ...visibleIds]))
  $dropdown.dropdown('set selected', merged)
}

function showChecklistFilterModal () {
  $('#confirm-checklist-filter').modal('show')
}

function showNoteFilterModal () {
  $('#confirm-note-filter').modal('show')
}

$('#checklist-filter-modal-confirm').click((ev) => {
  let filterKeyPrefix = 'issue'
  if (location.pathname === '/dashboard') {
    filterKeyPrefix = 'notable_issues'
  } else if (location.pathname === '/report/records') {
    filterKeyPrefix = 'report'
  }
  filterByChecklistsConfirm(filterKeyPrefix)
})

function filterByChecklistsConfirm (filterSetKeyPrefix, isActiveFiltering = true) {
  $('#record_type').dropdown('set selected', 'CHECKLIST')
  disableIssueOnlyFilters(filterSetKeyPrefix)

  handleFilterSelection(
    filterSetKeyPrefix,
    'record_type',
    'CHECKLIST',
    'CHECKLIST',
    isActiveFiltering
  )
}

$('#note-filter-modal-confirm').click((ev) => {
  let filterKeyPrefix = 'issue'
  let isActiveFiltering = true
  if (location.pathname === '/dashboard') {
    filterKeyPrefix = 'notable_issues'
  } else if (location.pathname === '/report/records') {
    filterKeyPrefix = 'report'
    isActiveFiltering = false
  }
  filterByNotesConfirm(filterKeyPrefix, isActiveFiltering)
})

function filterByNotesConfirm (filterSetKeyPrefix, isActiveFiltering = true) {
  $('#record_type').dropdown('set selected', 'NOTE')
  disableIssueOnlyFilters(filterSetKeyPrefix)

  handleFilterSelection(
    filterSetKeyPrefix,
    'record_type',
    'NOTE',
    'NOTE',
    isActiveFiltering
  )
}

function disableIssueOnlyFilters (filterSetKeyPrefix) {
  clearIssueOnlyFilters(filterSetKeyPrefix)
  $('.issue_only_filter').each(function (index, filter) {
    const itemSelector = '.issue_only_filter#' + filter.id + ' .item'
    $(itemSelector).each(function (index, item) {
      $(item).removeClass('active')
      $(item).removeClass('filtered')
    })

    const labelSelector = '.issue_only_filter#' + filter.id + ' a'
    $(labelSelector).each(function (index, label) {
      $(label).remove()
    })

    $(filter).dropdown('set value', '')
    $(filter).addClass('disabled')
  })

  $('#incomplete-issue-toggle').checkbox('uncheck')
  $('#incomplete-issue-toggle').addClass('disabled')
}

function enableIssueOnlyFilters () {
  $('.issue_only_filter').each(function (index, filter) {
    $(filter).removeClass('disabled')
  })
  $('#incomplete-issue-toggle').removeClass('disabled')
}

function clearIssueOnlyFilters (filterSetKeyPrefix) {
  // issue based filters
  filters[filterSetKeyPrefix + '_filters'].priorities = {}
  filters[filterSetKeyPrefix + '_filters'].categories = {}
  filters[filterSetKeyPrefix + '_filters'].show_incomplete_only = false
  filters[filterSetKeyPrefix + '_filters'].locations = {}
  filters[filterSetKeyPrefix + '_filters'].resolutions = {}

  return filters
}

/**
 * @param filterSetKeyPrefix
 * @param type
 * @param id
 * @param value
 * @param isActiveFiltering
 */
function handleFilterSelection (filterSetKeyPrefix, type, id, value, isActiveFiltering = true) {
  if (isActiveFiltering) {
    $('#loadingIcon').show()
  }

  switch (type) {
    case 'record_status':
      if (id === 'active') {
        filters[filterSetKeyPrefix + '_filters'].active_status = true
      }

      if (id === 'inactive') {
        filters[filterSetKeyPrefix + '_filters'].inactive_status = true
      }
      break

    case 'issue_status':
      filters[filterSetKeyPrefix + '_filters'].issue_statuses[value] = id
      break

    case 'logs':
      filters[filterSetKeyPrefix + '_filters'].logs[value] = id
      break

    case 'priorities':
      filters[filterSetKeyPrefix + '_filters'].priorities[value] = id
      break

    case 'categories':
      filters[filterSetKeyPrefix + '_filters'].categories[value] = id
      selectedCategories.push(id)
      handleChildrenOnAdd(filterSetKeyPrefix, $('div[data-parent-id="' + id + '"], div[data-grandparent-id="' + id + '"]'))
      break

    case 'record_type':
      filters[filterSetKeyPrefix + '_filters'].record_type = id
      break

    case 'locations':
      filters[filterSetKeyPrefix + '_filters'].locations[value] = id
      break

    case 'resolutions':
      filters[filterSetKeyPrefix + '_filters'].resolutions[value] = id
      selectedResolutions.push(id)
      handleResolutionChildrenOnAdd(filterSetKeyPrefix, $('div[data-parent-id="' + id + '"]'))
      break

    case 'permission_groups':
      filters[filterSetKeyPrefix + '_filters'].permission_groups[value] = id
      break

    case 'teams':
      filters[filterSetKeyPrefix + '_filters'].teams[value] = id
      break

    case 'sms_thread_status':
      filters[filterSetKeyPrefix + '_filters'].sms_thread_status[value] = id
      break
  }

  filters[filterSetKeyPrefix + '_filters'].page = 1

  if (isActiveFiltering) {
    fetchResults(
      buildPostJson(filters), filterSetKeyPrefix
    )
  }

  const event = new Event('FiltersUpdated')
  document.dispatchEvent(event)
}

/**
 * @param filterSetKeyPrefix
 * @param type
 * @param id
 * @param value
 * @param isLozengeRemoval
 * @param isActiveFiltering
 */
function handleFilterRemoval (filterSetKeyPrefix, type, id, value, isLozengeRemoval, isActiveFiltering = true) {
  if (isActiveFiltering) {
    $('#loadingIcon').show()
  }

  switch (type) {
    case 'page':
      break
    case 'page_limit':
      break

    case 'date_range':
      $('#from-date').datepicker('clearDates')
      $('#to-date').datepicker('clearDates')

      delete filters.user_filters.date_range.from_date
      delete filters.user_filters.date_range.to_date
      break

    case 'from-date':
      $('#from-date').datepicker('clearDates')

      filters[filterSetKeyPrefix + '_filters'].from_date = null
      break

    case 'to-date':
      $('#to-date').datepicker('clearDates')

      filters[filterSetKeyPrefix + '_filters'].to_date = null
      break

    case 'show-incomplete-only':
      $('#incomplete-issue-toggle').checkbox('set unchecked')
      filters[filterSetKeyPrefix + '_filters'].show_incomplete_only = false
      break

    case 'record_status':
      if (id === 'active') {
        filters[filterSetKeyPrefix + '_filters'].active_status = null
      } else if (id === 'inactive') {
        filters[filterSetKeyPrefix + '_filters'].inactive_status = null
      }
      break

    case 'status':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#record_status').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].active_status = null
        filters[filterSetKeyPrefix + '_filters'].inactive_status = null
      } else {
        filters[filterSetKeyPrefix + '_filters'].active_status = null
        filters[filterSetKeyPrefix + '_filters'].inactive_status = null
      }
      break

    case 'issue_status':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#issue_status').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].issue_statuses = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].issue_statuses[value]
      }
      break

    case 'priorities':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#priorities').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].priorities = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].priorities[value]
      }
      break

    case 'logs':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#logs').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].logs = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].logs[value]
      }
      break

    case 'permission_groups':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#permission_groups').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].permission_groups = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].permission_groups[value]
      }
      break

    case 'teams':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#teams').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].teams = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].teams[value]
      }
      break

    case 'categories':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#categories').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].categories = {}
        selectedCategories = []
      } else {
        removeCategoryFilter(filterSetKeyPrefix, id, value)
        handleChildrenOnRemove($('div[data-parent-id="' + id + '"], div[data-grandparent-id="' + id + '"]'))
      }
      break

    case 'locations':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#locations').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].locations = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].locations[value]
      }
      break

    case 'resolutions':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#resolutions').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].resolutions = {}
        selectedResolutions = []
      } else {
        removeResolutionFilter(filterSetKeyPrefix, id, value)
        handleResolutionChildrenOnRemove($('div[data-parent-id="' + id + '"]'))
      }
      break

    case 'record-type':
      $('.ui.fluid.search.selection.dropdown#record_type').dropdown('clear')
      filters[filterSetKeyPrefix + '_filters'].record_type = null
      break

    case 'sms_thread_status':
      if (isLozengeRemoval) {
        $('.ui.fluid.multiple.search.selection.dropdown#sms_thread_status').dropdown('clear')
        filters[filterSetKeyPrefix + '_filters'].sms_thread_status = {}
      } else {
        delete filters[filterSetKeyPrefix + '_filters'].sms_thread_status[value]
      }
      break

    case 'hide_disabled':
      if (isLozengeRemoval) {
        $('#hide-disabled-profiles').click()
        filters.user_filters.hide_disabled = false
      } else {
        delete filters.user_filters.hide_disabled[value]
      }
      break
  }

  if (isActiveFiltering) {
    fetchResults(
      buildPostJson(filters), filterSetKeyPrefix
    )
  }

  const event = new Event('FiltersUpdated')
  document.dispatchEvent(event)
}

function handleLozengeFilterRemoval (filterSetKeyPrefix, event, isActiveFiltering = true) {
  if (isActiveFiltering) {
    $('#loadingIcon').show()
  }
  const type = event.target.dataset.filterType

  handleFilterRemoval(filterSetKeyPrefix, type, null, null, true, isActiveFiltering)
}

// Category functions
function handleChildrenOnAdd (filterSetKeyPrefix, el) {
  el.each((key, value) => {
    removePill(value.dataset.value)
    removeCategoryFilter(filterSetKeyPrefix, value.dataset.value, value.dataset.name)
    disableOption(value.dataset.value)
  })
}

function handleChildrenOnRemove (el) {
  el.each((key, value) => {
    enableOption(value.dataset.value)
  })
}

function removeCategoryFilter (filterSetKeyPrefix, id, value) {
  delete filters[filterSetKeyPrefix + '_filters'].categories[value]

  const index = selectedCategories.indexOf(id)
  if (index !== -1) {
    selectedCategories.splice(index, 1)
  }
}

function removePill (id) {
  $('a[data-value="' + id + '"] > .delete').click()
}

function disableOption (id) {
  $('div[data-value="' + id + '"]').addClass('active')
  $('div[data-value="' + id + '"]').addClass('filtered')
}

function enableOption (id) {
  $('div[data-value="' + id + '"]').removeClass('active')
  $('div[data-value="' + id + '"]').removeClass('filtered')
}

// Resolution functions
function handleResolutionChildrenOnAdd (filterSetKeyPrefix, el) {
  el.each((key, value) => {
    removePill(value.dataset.value)
    removeResolutionFilter(filterSetKeyPrefix, value.dataset.value, value.dataset.name)
    disableOption(value.dataset.value)
  })
}

function handleResolutionChildrenOnRemove (el) {
  el.each((key, value) => {
    enableOption(value.dataset.value)
  })
}

function removeResolutionFilter (filterSetKeyPrefix, id, value) {
  delete filters[filterSetKeyPrefix + '_filters'].resolutions[value]

  const index = selectedResolutions.indexOf(id)
  if (index !== -1) {
    selectedResolutions.splice(index, 1)
  }
}

export { initDropdowns, handleChildrenOnAdd, handleLozengeFilterRemoval, enableSelectAllFiltered }
